<template>
  <div>
    You are being signed out...
  </div>
</template>

<script>

import {AUTH_LOGOUT} from '@/store/actions/auth.js'

export default {
  created() {
    this.$store.dispatch(AUTH_LOGOUT).then(() => {
      this.$router.push({name: 'home'})
    })
  }
}
</script>

<style scoped>

</style>